const allowedExtensions = '.csv,.xml,.pdf,.png,.jpg,.jpeg';
export default allowedExtensions;
